// This file contains types for mocking all the APIs the BFF calls (we call the APIs the BFF calls "provider APIs")

import {
  BillingDetailsV2,
  IdCardsUrlV2,
  PolicyDetailsV2,
} from "@hagerty/customer-insurance-gateway-client";

import { Source } from "..";

import { ESignDocumentsResponse } from "./ESignDocumentsResponse.types";
import { Hdc1Dot0MembershipResponse } from "./Hdc1Dot0MembershipResponse.types";
import {
  Hdc1Dot5MembershipDetailsResponse,
  Hdc1Dot5MembershipProfileResponse,
} from "./Hdc1Dot5MembershipResponse.types";
import { SoulGqlResponse } from "./SoulResponse.types";
import { EndorsementResponse } from "./EndorsementResponse.types";
import { UpdateVehicleCoverageResponse } from "./UpdateVehicleCoverageResponse.types";
import { MemberGqlResponse } from "./MemberGqlResponse.types";
import { PayEndorsementUrlResponse } from "./PayEndorsementUrlResponse.types";
import { BillingGqlResponse } from "./BillingGqlResponse.types";

// Responses that only apply to some personas are optional.
// If mockProvidersServer sees a missing type, it returns the empty request equivalent.
// For example, if the hdc property is omitted, it returns the null for those calls since that's what they do when there's no record.
// This convention keeps mocks as lean as possible.
export type ProviderApiMockResponses = {
  // TODO: We should mock Apex responses instead of CIG, see #273204
  cig: {
    billing: BillingDetailsV2;
    policies: Record<Source, PolicyDetailsV2[]>;
    policyIdCardUrls?: Record<string, IdCardsUrlV2>;
  };
  /**
   * @deprecated No longer used, replaced by member.
   */
  hdc?: {
    fetch1Dot0Membership?: Hdc1Dot0MembershipResponse;
    fetch1Dot5MembershipId?: Hdc1Dot5MembershipProfileResponse;
    fetch1Dot5MembershipDetails?: Hdc1Dot5MembershipDetailsResponse;
  };
  esign?: {
    fetchESignDocuments: ESignDocumentsResponse[];
    createESignRequest: "success" | "error";
  };
  insurance: {
    fetchEndorsement: EndorsementResponse;
    updateVehicleCoverages?: UpdateVehicleCoverageResponse;
    stream?: "success" | "error";
  };
  soul: {
    fetchSoul: SoulGqlResponse;
  };
  billing: {
    fetchBilling?: BillingGqlResponse;
  };
  payments: {
    fetchPayEndorsementUrl?: PayEndorsementUrlResponse;
  };
  member: {
    fetchMember?: MemberGqlResponse;
  };
};

// Centralizing various mock responses below for reuse...

// HDC 1.0 returns an empty record for non-members
const noHdc1Dot0MembershipResponse: Hdc1Dot0MembershipResponse = {
  EffectiveDate: "",
  ExpirationDate: "",
  ProductCode: "",
  membershipID: "",
};

export const hdcMocks = {
  fetchHdc1Dot0Membership: {
    noAccount: noHdc1Dot0MembershipResponse,
  },
};
